//
// Hero video
//
import YouTubePlayer from 'youtube-player'
import { onPlayerStateChange } from '../../gtm/youtube'
;(($) => {
    $(() => {
        let modules = document.querySelectorAll('.hero-video-element')

        // Only continue if module is on page
        if (!modules.length) return

        window.dataLayer = window.dataLayer || []

        modules.forEach((videoElement) => {
            const youtubeVideo = videoElement.querySelector('.hero-video-youtube')
            const assetVideo = videoElement.querySelector('.hero-video-asset')
            if (youtubeVideo) {
                const ytVideoID = youtubeVideo.getAttribute('data-video-id')
                const placeholderID = youtubeVideo.id
                const autoplay = Boolean(youtubeVideo.getAttribute('data-autoplay'))
                const loop = Boolean(youtubeVideo.getAttribute('data-loop'))
                const mute = Boolean(youtubeVideo.getAttribute('data-mute'))

                const player = YouTubePlayer(placeholderID, {
                    width: null,
                    height: null,
                    videoId: ytVideoID,
                    playerVars: { autoplay: +autoplay, loop: +loop },
                })

                if (mute) {
                    player.mute()
                } else {
                    player.setVolume(30)
                    player.unMute()
                }

                // When autoplay is enabled, the first state=1 is from autoplay — suppress GA4 for it
                let isAutoplayFirstPlay = autoplay
                player.on('stateChange', (event) => {
                    const isAutoplayEvent = isAutoplayFirstPlay && event.data === 1
                    if (event.data === 1) isAutoplayFirstPlay = false
                    onPlayerStateChange(event, isAutoplayEvent)
                })
            } else if (assetVideo) {
                const video = assetVideo.querySelector('video')
                if (video) {
                    let hasPlayFired = false
                    video.addEventListener('click', () => {
                        if (!video.paused || hasPlayFired) return
                        hasPlayFired = true
                        let title = ''
                        try {
                            title = decodeURIComponent(video.currentSrc.match(/([^/]+)(?=\.\w+$)/)[0])
                        } catch (e) { /* no-op */ }
                        window.dataLayer.push({
                            event: 'video_play',
                            video_title: title,
                            video_percent: 0,
                        })
                    })
                }
            }
        })
    })
})(jQuery)
